import { Loader } from "@productlane/ui"

import { api } from "@/lib/api"

export function ApiTopWorkspacesChart() {
	const query = api.apiAnalytics.adminTopWorkspaces.useQuery({ days: 14 })

	return (
		<div className="rounded-lg border p-4">
			<h3 className="mb-3 text-sm font-medium text-gray-800 dark:text-white">
				Top API workspaces (last 14 days)
			</h3>
			{query.isLoading || !query.data ? (
				<div className="flex h-32 items-center justify-center">
					<Loader />
				</div>
			) : query.data.length === 0 ? (
				<div className="text-xs text-secondary">No API traffic.</div>
			) : (
				<div className="flex flex-col gap-1 text-xs">
					{query.data.map((row) => (
						<div
							key={row.workspaceId}
							className="flex items-center justify-between gap-2"
						>
							<span className="truncate">
								<span className="font-medium">{row.name}</span>{" "}
								<span className="text-secondary">
									({row.domain ?? row.workspaceId})
								</span>
							</span>
							<span className="tabular-nums">{row.count.toLocaleString()}</span>
						</div>
					))}
				</div>
			)}
		</div>
	)
}
